import React, { useState, useContext } from "react";
import Ctx from "../../contexts/AppContext";
import { crd, bdg } from "../../constants/styles";

function SpHistory({ sp }) {
  const { t, h, go, setSelMaintId } = useContext(Ctx);
  const [expandedId, setExpandedId] = useState(null);
  const spJobs = sp.data?.jobs || []; const spTens = sp.data?.tens || []; const spProps = sp.data?.props || []; const spPayments = sp.data?.payments || [];

  const completed = spJobs.filter(j => j.sp_status === 'completed' || j.confirmed_by_tenant);
  const verified = completed.filter(j => j.confirmed_by_tenant).length;
  const uc = { high: h.rd, med: h.wn, low: h.gn };
  if (sp.loading) return <div style={{ paddingTop: 40, textAlign: "center" }}><div style={{ color: h.sc, fontSize: 13 }}>{t.syncingDb}</div></div>;

  return <div style={{ paddingTop: 16 }}>
    <h2 style={{ color: h.tx, fontSize: 18, fontWeight: 700, margin: "0 0 12px" }}>{t.history}</h2>
    {completed.length > 0 && <div style={{ display: "flex", gap: 8, marginBottom: 16 }}>
      <div style={{ flex: 1, background: `${h.gn}15`, borderRadius: 10, padding: "10px 12px", textAlign: "center" }}>
        <div style={{ color: h.gn, fontWeight: 700, fontSize: 20 }}>{completed.length}</div>
        <div style={{ color: h.sc, fontSize: 10 }}>{t.completedJobs}</div>
      </div>
      <div style={{ flex: 1, background: `${h.ac}15`, borderRadius: 10, padding: "10px 12px", textAlign: "center" }}>
        <div style={{ color: h.ac, fontWeight: 700, fontSize: 20 }}>{verified}</div>
        <div style={{ color: h.sc, fontSize: 10 }}>{t.completionVerified}</div>
      </div>
    </div>}
    {completed.length === 0 && <div style={{ color: h.sc, textAlign: "center", padding: 40, fontSize: 13 }}>{t.noCompletedJobs}</div>}
    {[...completed].sort((a, b) => {
      // Awaiting tenant verification first; verified jobs after
      if (!!a.confirmed_by_tenant !== !!b.confirmed_by_tenant) return a.confirmed_by_tenant ? 1 : -1;
      // Within each group, newest first (id format "m<timestamp>")
      return (b.id || "").localeCompare(a.id || "");
    }).map(j => { const ten = spTens.find(x => x.id === j.tid); const prop = ten ? spProps.find(x => x.id === ten.pid) : (spProps.length === 1 ? spProps[0] : null);
      const pay = spPayments.find(p => p.maint_id === j.id);
      const isExpanded = expandedId === j.id;
      return <div key={j.id} onClick={() => setExpandedId(isExpanded ? null : j.id)} style={{ ...crd(h), cursor: "pointer", transition: "all .2s" }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "start", marginBottom: 4 }}>
          <div style={{ flex: 1 }}>
            <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
              <div style={{ color: h.tx, fontWeight: 600, fontSize: 13 }}>{j.desc}</div>
              <span style={bdg(`${uc[j.urg] || h.wn}20`, uc[j.urg] || h.wn)}>{j.urg === "high" ? t.high : j.urg === "med" ? t.med : t.low}</span>
            </div>
            <div style={{ color: h.sc, fontSize: 11, marginTop: 2 }}>{ten?.name || "General"} · {prop?.addr || "—"}</div>
            <div style={{ color: h.sc, fontSize: 10, marginTop: 2 }}>{j.dt}</div>
          </div>
          <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-end", gap: 4, flexShrink: 0 }}>
            {j.confirmed_by_tenant ? <span style={bdg(`${h.gn}20`, h.gn)}>{"✓ " + t.completionVerified}</span> : <span style={bdg(`${h.wn}20`, h.wn)}>{t.pending}</span>}
          </div>
        </div>
        {/* Always show SP charges prominently */}
        {(() => {
          const payAmt = j.sp_pay_amt || pay?.amount || 0;
          const isPaid = j.sp_pay_st === 'paid' || pay?.st === 'paid';
          return payAmt > 0 ? <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginTop: 6, padding: "6px 10px", background: `${isPaid ? h.gn : h.wn}10`, borderRadius: 8, border: `1px solid ${isPaid ? h.gn : h.wn}25` }}>
            <span style={{ color: h.tx, fontSize: 12 }}>💰 {t.myCharges || "My Charges"}</span>
            <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
              <span style={{ color: isPaid ? h.gn : h.tx, fontWeight: 700, fontSize: 14 }}>₹{payAmt.toLocaleString()}</span>
              <span style={bdg(isPaid ? `${h.gn}20` : `${h.wn}20`, isPaid ? h.gn : h.wn)}>{isPaid ? "✅ Paid" : "⏳ Pending"}</span>
            </div>
          </div> : null;
        })()}
        {isExpanded && <div style={{ marginTop: 8, paddingTop: 8, borderTop: `1px solid ${h.bd}` }}>
          {j.sp_notes && <div style={{ color: h.tx, fontSize: 12, marginBottom: 8 }}><span style={{ fontWeight: 600 }}>{t.workNotes}:</span> {j.sp_notes}</div>}
          {j.asn_notes && <div style={{ color: h.sc, fontSize: 11, marginBottom: 8 }}><span style={{ fontWeight: 600 }}>{t.notes}:</span> {j.asn_notes}</div>}
          {(j.photo_before || j.photo_after) && <div style={{ marginBottom: 8 }}>
            <div style={{ color: h.sc, fontSize: 11, fontWeight: 600, marginBottom: 4 }}>{t.photoBefore} / {t.photoAfter}</div>
            <div style={{ display: "flex", gap: 8 }}>
              {j.photo_before && <div style={{ flex: 1 }}><img src={j.photo_before} alt="Before" style={{ width: "100%", borderRadius: 8, border: `1px solid ${h.bd}` }} /><div style={{ color: h.sc, fontSize: 9, textAlign: "center", marginTop: 2 }}>{t.photoBefore}</div></div>}
              {j.photo_after && <div style={{ flex: 1 }}><img src={j.photo_after} alt="After" style={{ width: "100%", borderRadius: 8, border: `1px solid ${h.bd}` }} /><div style={{ color: h.sc, fontSize: 9, textAlign: "center", marginTop: 2 }}>{t.photoAfter}</div></div>}
            </div>
          </div>}
          {/* Payment info — only show in expanded if NOT already shown on collapsed card */}
          {pay && !(j.sp_pay_amt > 0) && (() => {
            const payAmt = pay.amount || 0;
            const isPaid = pay.st === 'paid';
            return <div style={{ background: `${isPaid ? h.gn : h.wn}10`, padding: "8px 10px", borderRadius: 8 }}>
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <span style={{ color: h.tx, fontSize: 12, fontWeight: 600 }}>{t.jobPayment || "Payment"}</span>
                <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
                  <span style={{ color: h.tx, fontWeight: 700, fontSize: 14 }}>₹{payAmt.toLocaleString()}</span>
                  <span style={bdg(isPaid ? `${h.gn}20` : `${h.wn}20`, isPaid ? h.gn : h.wn)}>{isPaid ? t.paid : t.pending}</span>
                </div>
              </div>
              {pay?.dt && <div style={{ color: h.sc, fontSize: 10, marginTop: 4 }}>{pay.dt}</div>}
            </div>;
          })()}
          {j.confirmed_at && <div style={{ color: h.sc, fontSize: 10, marginTop: 6 }}>{"✓ " + t.completionVerified}: {new Date(j.confirmed_at).toLocaleDateString()}</div>}
          {ten?.ph && <a href={`tel:${ten.ph}`} onClick={e => e.stopPropagation()} style={{ color: h.ac, fontSize: 12, marginTop: 6, display: "inline-block" }}>{"📞 " + ten.ph}</a>}
          {/* Edit Charges button — always visible for SP to add/update their charges */}
          {j.sp_pay_st !== 'paid' && <button onClick={e => { e.stopPropagation(); setSelMaintId(j.id); go("spJobDetail"); }}
            style={{ width: "100%", marginTop: 8, padding: 10, borderRadius: 10, border: "none", background: h.ac, color: "#fff", fontSize: 12, fontWeight: 600, cursor: "pointer" }}>
            {(j.sp_pay_amt || 0) > 0 ? ("✏️ " + (t.editCharges || "Edit Charges")) : ("💰 " + (t.enterCharges || "Enter Charges"))}
          </button>}
        </div>}
        <div style={{ textAlign: "center", marginTop: 4 }}><span style={{ color: h.sc, fontSize: 10 }}>{isExpanded ? "▲" : "▼"}</span></div>
      </div>; })}
  </div>;
}

export default SpHistory;
